import React from "react";
import services from "../../services";
import { withRouter } from "react-router-dom";
import TitleBar from "../common/title_bar";
import SearchFilter from "../filters/SearchFilter";
import Main from "../../Pages/Demo/main";
import Lang from "../../lang";
import TlkTable from "../tlelrik/table/tlkTable";

const filters = {
    Tabs: {
        Entidade: [
            {
                key: "Entidade",
                displayKey: "Entidade",
                inputType: "text",
            },
            {
                key: "Estatuto",
                displayKey: "Estatuto",
                inputType: "text",
            },
        ],
    },
    checkbox: [],
};

const columnkeyMap = {
    codEntidadeName: "Entidade",
    codEstatutoName: "Estatuto",
};

class EntityRuleListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            tlkState: {},
            totalcount: "0",
            SortBy: "codEntidade",
            IsSortTypeDESC: false,
            Paginate: true,
            Page: 1,
            PageSize: 100,
            Filters: null,
            filterData: [],
            error: null,
            getServiceData: false,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createpayload();
    }

    createpayload = () => {
        let data = {
            Filters: this.state.Filters,
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.IsSortTypeDESC,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize,
        };
        this.getEntityRuleList(data);
    };
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        let Filters = {};
        // debugger;
        console.log(".........", customfilters);
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.Entidade
        )
            Filters["Entidade"] = customfilters.filters.Entidade;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.entity
        )
            Filters["EntidadeSearch"] = customfilters.filters.entity;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.Estatuto
        )
            Filters["Estatuto"] = customfilters.filters.Estatuto;

        this.setState(
            { Filters: Filters, telkikTable: null, getServiceData: true },
            () => this.createpayload()
        );
    };

    // getFilters = (data) => {
    // //console.log("data",data)
    // if(data){
    //     //console.log("data",data)
    //     this.setState({
    //         Filters : data
    //     },()=>this.createpayload())
    // }else{
    //     //console.log("data Else",data)
    //     this.setState({
    //         Filters : null
    //     },()=>this.createpayload())
    // }
    // }

    handleFilter = (data) => {
        // let actionbuttons= {Edit:true,Redirect:false,Delete:true}
        // let telkikTable = <Main date={new Date()} list={data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        // this.setState({
        //     telkikTable: null,
        //     filterData: data
        // }, () => this.createTabel())
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (row) => {
        try {
            let res = await services.apiCall.requestApi(
                `/BusEntidadeEstatuto/Delete/${row.codEntidade}`,
                {},
                "post"
            );
            if (res) {
                //console.log("res",res)
                this.createpayload();
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = () => {
        let actionbuttons = { Edit: true, Redirect: false, Delete: true };
        let telkikTable = (
            <TlkTable
                date={new Date()}
                modulename={"entityRule"}
                deleteFunc={(id) => this.handleDelete(id)}
                list={this.state.filterData}
                tlkState={this.state.tlkState}
                tableFilters={(filter) => this.tableFilters(filter)}
                actionbuttons={actionbuttons}
                columnlist={this.columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />
        );
        this.setState({
            telkikTable: telkikTable,
        });
    };

    tableFilters = (filter) => {
        try {
            if (
                JSON.stringify(filter) !== JSON.stringify(this.state.tlkState)
            ) {
                let tlkState = { ...filter };
                let SortBy = "ID";
                let IsSortTypeDESC = false;
                let columnkeyMaprev = {};
                for (var key in columnkeyMap) {
                    columnkeyMaprev[columnkeyMap[key]] = key;
                }
                if (filter && filter.sort && filter.sort.length > 0) {
                    SortBy = columnkeyMaprev[filter.sort[0].field];
                    IsSortTypeDESC =
                        filter.sort[0].dir === "asc" ? false : true;
                }
                console.log("filter", filter);
                this.setState(
                    {
                        Page: Math.ceil(filter.skip / filter.take) + 1,
                        PageSize: filter.take || 100,
                        SortBy,
                        IsSortTypeDESC,
                        tlkState,
                    },
                    () => {
                        this.createpayload();
                    }
                );
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        try {
            if (action == "Edit") {
                //console.log("row.codEntidade",row)
                this.props.history.push({
                    pathname: "/entity_rule_form",
                    search: "id=" + row.codEntidade,
                    state: {
                        // entidade_id: row.codEntidade,
                        topBarMenu: this.props.topBarMenuOption,
                    },
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };
    // GetServiceData = async () => {
    //     fetch(
    //         `https://sbase.ivdp.pt/REST/Estatutos/GetEstatutosByEntidade?idEntidade=35608`,
    //         { mode: "no-cors" }
    //     )
    //         .then((res) => {
    //             return res;
    //         })
    //         .then((response) => console.log(response))
    //         .catch((err) => console.log);
    // };
    getEntityRuleList = async (data) => {
        try {
            console.log("Dattaattatata", data);
            let _user = await services.apiCall.requestApi(
                "/BusEntidadeEstatuto/GetAll",
                data,
                "post"
            );
            // if (this.state.getServiceData) {
            //     this.GetServiceData();
            //     return;
            // }
            if (_user) {
                _user.map((_row, index) =>
                    Object.keys(columnkeyMap).map(function (key) {
                        _row[columnkeyMap[key]] = _row[key];
                    })
                );
                this.setState(
                    {
                        data: _user,
                        filterData: _user,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => this.createTabel()
                );
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    render() {
        //console.log("hjdsdk",this.state.Filters)
        if (this.state.error) {
            throw this.state.error;
        }
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        path={"/entity_rule_form"}
                        topBarMenu={this.props.topBarMenuOption}
                        title="Estatutos de Entidade"
                        logo="auditing"
                    />
                    <SearchFilter
                        showEntity={true}
                        searchplaceholder={"Pesquise por nome de entidade"}
                        filters={filters}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        getFilter={(data) => this.getFilters(data)}
                    />
                    <div className="table-responsive table-section">
                        <h3>
                            {" "}
                            A pesquisa retornou {this.state.totalcount}{" "}
                            resultados{" "}
                        </h3>
                        {this.state.telkikTable}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EntityRuleListComponent);
